// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 252 ? "__federation_expose_AppMount" : chunkId) + "." + {"31":"f7cb8a6b","69":"32e6e317","124":"8eb5d9f7","252":"ef5d4446","418":"7363f478","442":"e90d5955","443":"301a44cd","474":"4347b7f9","477":"4a61909f","628":"a0190ae0","965":"ede950b5"}[chunkId] + ".chunk.js";
};